document.addEventListener('DOMContentLoaded', () => {
  const productCards$ = document.querySelectorAll('.children-collections-section .product-card[data-url]');

  productCards$.forEach((card$) => {
    card$.addEventListener('click', (event) => {
      const link$ = event.target.closest('a');
      if (link$) return;

      const url = card$.dataset.url;
      const openInNewTab = card$.dataset.openInNewTab === 'true';

      if (url) {
        if (openInNewTab) {
          window.open(url, '_blank', 'noopener,noreferrer');
        } else {
          window.location.href = url;
        }
      }
    });
  });
});
